import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { CheckoutButton } from './Button';
const productImage = 'https://cdn.magicpatterns.com/uploads/5TWZFS4F6oyr6iQZA4tkNM/seguridad_e_higiene_(4).png';
export function Hero() {
  return <section className="relative overflow-hidden bg-charcoal px-4 pb-16 pt-10 sm:pb-20 sm:pt-14" data-id="element-145">
      <div className="absolute inset-x-0 top-0 h-[34rem] bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,.16),transparent_66%)]" aria-hidden="true" data-id="element-146" />
      <div className="relative mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55
      }} data-id="element-148">
          <p className="mb-5 inline-flex rounded-full border border-gold/35 bg-gold/10 px-3 py-1 text-xs font-semibold tracking-wide text-gold-light" data-id="element-149">
            DANCE FITNESS INSTRUCTOR PRO™
          </p>
          <h1 className="font-display text-4xl font-bold leading-[1.08] tracking-tight text-white sm:text-5xl md:text-6xl" data-id="element-150">
            Solve an entire year of classes{' '}
            <span className="gold-text" data-id="element-151">in just 5 minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.14,
        duration: 0.55
      }} className="relative my-5 w-full max-w-[285px] sm:my-7 sm:max-w-md" data-id="element-152">
          <div className="absolute inset-0 rounded-full bg-gold/15 blur-[72px]" aria-hidden="true" data-id="element-153" />
          <img src={productImage} alt="Dance Fitness Instructor Pro complete ready-to-teach system" className="relative mx-auto w-full object-contain drop-shadow-[0_28px_42px_rgba(0,0,0,.7)]" data-id="element-154" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.28,
        duration: 0.5
      }} data-id="element-155">
          <p className="mx-auto mb-6 max-w-2xl text-base leading-relaxed text-zinc-300 sm:text-lg" data-id="element-156">
            The complete ready-to-teach system with one full year of dance
            fitness classes, choreographies, planning tools, and professional
            resources.
          </p>
          <CheckoutButton data-id="element-157">GET THE COMPLETE TEACHING SYSTEM NOW</CheckoutButton>
          <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-zinc-400" data-id="element-158">
            {['120 Ready-to-Teach Classes', '5 Strategic Bonuses', 'Immediate Access'].map(item => <span key={item} className="flex items-center gap-1.5" data-id="element-159">
                <CheckCircle2Icon size={15} className="text-gold-light" data-id="element-160" />
                {item}
              </span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}